import { render, staticRenderFns } from "./CKeditor.vue?vue&type=template&id=1b9b5322&"
import script from "./CKeditor.vue?vue&type=script&lang=js&"
export * from "./CKeditor.vue?vue&type=script&lang=js&"
import style0 from "./CKeditor.vue?vue&type=style&index=0&id=1b9b5322&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports